import { Controller } from '@hotwired/stimulus';
import { useResize } from 'stimulus-use';

export default class extends Controller {
  static targets = ['header'];

  connect() {
    this.headerElement = this.headerTarget;
    useResize(this, { element: this.headerElement });
  }

  resize() {
    if (!this.headerElement) return;

    const height = this.headerElement.offsetHeight + 20;

    if (height > 0) {
      this.element.style.setProperty('--header-height', `${height}px`);
    }
  }
}
